const getNextOfKinModel = () => ({
  emergencyContactDetailsId: null,
  firstName: '',
  lastName: '',
  email: '',
  mobileNumber: '',
  phoneNumber: '',
  phoneNumber2: '',
  relationship: '',
  address: {
    addressLines: [],
    addressVerified: false,
    country: '',
    county: '',
    postCode: '',
    town: '',
  }
});

export {
  getNextOfKinModel
};